// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import _ from 'underscore';

import {AssemblySlotType, AssemblySlots} from 'assembly/AssemblyModels';
import {assertAndContinue} from 'Asserts';
import {Sequence as BioJSSequence} from 'biojs/Sequence';
import {Sequence} from 'components/Sequence';
import FileStates from 'FileStates';
import {Selection} from 'molbio/maps/selectables/Selection';

class SingleFragmentSlotView extends Backbone.View<AssemblySlotType> {
  isRemoved!: boolean;
  listeningSequences!: Array<BioJSSequence>;
  fileStates!: FileStates;
  sequence?: Sequence;
  selection?: Selection;

  static initClass(): void {
    this.prototype.tagName = 'li';
    this.prototype.fileStates = FileStates.get();
  }

  events(): Backbone.EventsHash {
    return {
      'click .js-delete': 'deleteSlot',
      'click .js-shift-left': 'shiftLeft',
      'click .js-shift-right': 'shiftRight',
      'click .js-insert-spacer': 'insertSpacer',
    };
  }

  initialize(options: unknown): void {
    this.isRemoved = false;
    this.listeningSequences = [];
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model, 'change:active slotChange', this.render);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.fileStates, 'reset add remove', this.listenToSequences);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model.fragments(), 'add remove change:sequenceID', this.listenToSequences);
    this.listenToSequences();
  }

  listenToSequences(): void {
    if (this.isRemoved) {
      return;
    }

    for (const _sequence of this.listeningSequences) {
      this.stopListening(_sequence);
    }
    this.listeningSequences = _.compact(
      this.model.fragments().map((fragment) => {
        const _sequence = __guard__(fragment.getSequence(), (x: Sequence) => x.get('_sequence'));
        if (_sequence == null) {
          return null;
        }
        this.listenTo(_sequence, 'change:bases change:circular', () => {
          fragment.stopListening();
          fragment.destroy({
            error() {
              // Assert false for now to get a stack trace to help with debugging T571
              assertAndContinue(false, 'fragment.destroy() failed');
            },
          });
        });
        return _sequence;
      })
    );
  }

  shiftLeft(): void {
    this.model.shiftLeft();
  }

  shiftRight(): void {
    this.model.shiftRight();
  }

  insertSpacer(): void {
    const index = this.model.index()! + 1;
    // @ts-expect-error This might be fine, AssemblySlot applies default values
    (this.model.collection as AssemblySlots).addSlot({name: '', spacer: ''}, index);
  }

  deleteSlot(): void {
    if (this.$('.js-delete').hasClass('is-disabled')) {
      return;
    }
    this.model.destroy();
  }

  toggleDelete(): void {
    const notDeletable = !this.model.isSpacer() && this.model.index() === 0;
    this.$('.js-delete').toggleClass('is-disabled', notDeletable);
  }

  updateSequence(sequence: Sequence): void {
    if (this.selection != null) {
      this.stopListening(this.selection);
    }
    this.sequence = sequence;
    this.selection = sequence != null ? sequence.get('selection') : undefined;
  }

  remove(): Backbone.View<AssemblySlotType> {
    this.isRemoved = true;
    this.$('[data-toggle="tooltip"]').tooltip('destroy');
    return super.remove();
  }
}
SingleFragmentSlotView.initClass();

export default SingleFragmentSlotView;

function __guard__<T, R>(value: T | undefined | null, transform: (val: T) => R): R | undefined {
  return value != null ? transform(value) : undefined;
}
